import { ReactNode } from 'react'
import { withAuthenticationRequired } from '@auth0/auth0-react'

interface Props {
  children?: ReactNode
}

const AuthenticationRequired = ({ children }: Props): JSX.Element => {
  return <>{children}</>
}

export default withAuthenticationRequired(AuthenticationRequired)
